import Dexie, { Table } from 'dexie';

export interface ExtratoCarteiraPrevidencia {
  id?: number;
  ev: number;
  cpf: string;
  proposta: string;
  data_inicial: string;
  data_final: string;
  pdf_url: string;
  pdf_date_expiration: number;
}

export class DexieDatabase extends Dexie {
  extratoCarteira!: Table<ExtratoCarteiraPrevidencia>;

  constructor() {
    super('plataforma-negocios');
    this.version(1).stores({
      extratoCarteira:
        '++id, ev, cpf, proposta, data_inicial, data_final, pdf_url, pdf_date_expiration, [cpf+proposta]'
    });
  }
}

export const db = new DexieDatabase();
